import UITypes from './UITypes';
export var GenericValidationType;
(function (GenericValidationType) {
    GenericValidationType["Required"] = "required";
})(GenericValidationType || (GenericValidationType = {}));
export var StringValidationType;
(function (StringValidationType) {
    StringValidationType["MinLength"] = "minLength";
    StringValidationType["MaxLength"] = "maxLength";
    StringValidationType["StartsWith"] = "startsWith";
    StringValidationType["EndsWith"] = "endsWith";
    StringValidationType["Includes"] = "includes";
    StringValidationType["NotIncludes"] = "notIncludes";
    StringValidationType["Regex"] = "regex";
    StringValidationType["Email"] = "email";
    StringValidationType["BusinessEmail"] = "businessEmail";
    StringValidationType["PhoneNumber"] = "phoneNumber";
    StringValidationType["Url"] = "url";
})(StringValidationType || (StringValidationType = {}));
export var NumberValidationType;
(function (NumberValidationType) {
    NumberValidationType["Min"] = "min";
    NumberValidationType["Max"] = "max";
})(NumberValidationType || (NumberValidationType = {}));
export var DateValidationType;
(function (DateValidationType) {
    DateValidationType["MinDate"] = "minDate";
    DateValidationType["MaxDate"] = "maxDate";
})(DateValidationType || (DateValidationType = {}));
export var TimeValidationType;
(function (TimeValidationType) {
    TimeValidationType["MinTime"] = "minTime";
    TimeValidationType["MaxTime"] = "maxTime";
})(TimeValidationType || (TimeValidationType = {}));
export var YearValidationType;
(function (YearValidationType) {
    YearValidationType["MinYear"] = "minYear";
    YearValidationType["MaxYear"] = "maxYear";
})(YearValidationType || (YearValidationType = {}));
export var SelectValidationType;
(function (SelectValidationType) {
    SelectValidationType["MinSelected"] = "minSelected";
    SelectValidationType["MaxSelected"] = "maxSelected";
    SelectValidationType["LimitOptions"] = "limitOptions";
})(SelectValidationType || (SelectValidationType = {}));
export var AttachmentValidationType;
(function (AttachmentValidationType) {
    AttachmentValidationType["FileTypes"] = "fileTypes";
    AttachmentValidationType["FileSize"] = "fileSize";
    AttachmentValidationType["FileCount"] = "fileCount";
})(AttachmentValidationType || (AttachmentValidationType = {}));
export const oppositeValidationTypeMap = {
    [StringValidationType.MaxLength]: StringValidationType.MinLength,
    [StringValidationType.NotIncludes]: StringValidationType.Includes,
    [NumberValidationType.Max]: NumberValidationType.Min,
    [YearValidationType.MaxYear]: YearValidationType.MinYear,
    [DateValidationType.MaxDate]: DateValidationType.MinDate,
    [TimeValidationType.MaxTime]: TimeValidationType.MinTime,
    [SelectValidationType.MaxSelected]: SelectValidationType.MinSelected,
};
export const hideExtraFieldsMetaKey = 'hideExtraFields';
/**
 * Maximum number of form fields that can share a single horizontal row in a
 * form view grid layout. Used by both the backend validator and the frontend
 * drag-drop editor to enforce the cap.
 */
export const FORM_ROW_MAX_FIELDS = 5;
/**
 * UI types that always occupy their own full-width row in the form view —
 * multi-line / large inputs are too wide to share a row with other fields.
 */
export const FORM_ROW_FULL_WIDTH_UI_TYPES = [
    UITypes.LongText,
    UITypes.Attachment,
    UITypes.JSON,
];
/**
 * Group an ordered list of form columns into horizontal rows based on `row_id`.
 *
 * Rules:
 * - Columns with the same non-null `row_id` are grouped into one row.
 * - Columns with a null/undefined `row_id` occupy their own single-field row.
 * - Columns whose uidt is in {@link FORM_ROW_FULL_WIDTH_UI_TYPES} are always
 *   promoted to their own row, regardless of `row_id`.
 * - Row order is determined by the position of the row's first column in the
 *   input list (which the caller is expected to sort by `order` first).
 *
 * The input must already be sorted by `order` — grouping preserves that order
 * both across rows and within each row.
 */
export function groupFormColumnsByRow(columns) {
    var _a;
    // Walk the list in order and maintain the "currently open" row — a new
    // row opens whenever row_id changes or we hit a full-width field (which
    // must be alone). Contiguous same-row_id runs group into one row;
    // non-contiguous runs create separate rows so visual order is preserved.
    const rows = [];
    let currentRow = null;
    let currentRowId = null;
    for (const col of columns) {
        const rowId = (_a = col.row_id) !== null && _a !== void 0 ? _a : null;
        const isFullWidth = col.uidt != null &&
            FORM_ROW_FULL_WIDTH_UI_TYPES.includes(col.uidt);
        if (isFullWidth || rowId == null) {
            rows.push([col]);
            currentRow = null;
            currentRowId = null;
            continue;
        }
        if (currentRow && currentRowId === rowId) {
            currentRow.push(col);
        }
        else {
            currentRow = [col];
            currentRowId = rowId;
            rows.push(currentRow);
        }
    }
    return rows;
}
//# sourceMappingURL=data:application/json;base64,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